import React, { useEffect, useState } from "react";

const OverviewDashboard = (props) => {
  const { periodSelected, chartsData } = props;
  const [dashboardOverviewData, setDashboardOverviewData] = useState({
    averageUsers: 0,
    averageChats: 0,
    averageSessions: 0,
    totalLocations: 0,
  });

  const calculateAverageData = () => {
    let totalReplies = 0;
    let totalSessions = 0;
    let totalUsers = 0;
    let count = 0;
    const locationSet = new Set();
    const uniqueUserSet = new Set();

    chartsData?.forEach((entry) => {
      const skill = entry.skills[0]; // only 1 skill per entry
      totalReplies += skill.totalReplies;
      totalSessions += skill.totalSessions;
      //totalUsers += skill.uniqueUser;
      skill.uniqueUserName?.forEach((username) => {
        uniqueUserSet.add(username);
      });
      skill.location.forEach((loc) => {
        const locKey = `${loc.lat},${loc.long}`;
        locationSet.add(locKey);
      });
      count++;
    });

    //const number = parseInt(periodSelected.match(/\d+/)[0], 10);
    // const result = {
    //   averageReplies: +(totalReplies / number).toFixed(0),
    //   averageSessions: +(totalSessions / number).toFixed(0),
    //   averageUniqueUsers: +(totalUsers / number).toFixed(0),
    //   totalLocations: locationSet.size,
    // };

    const result = {
      totalUsers: uniqueUserSet?.size,
      totalReplies: totalReplies,
      totalSessions: totalSessions,
      totalLocations: locationSet.size,
    };

    // setDashboardOverviewData({
    //   averageUsers: result.averageUniqueUsers,
    //   averageChats: result.averageReplies,
    //   averageSessions: result.averageSessions,
    //   totalLocations: result.totalLocations,
    // });
    setDashboardOverviewData({
      totalUsers: result.totalUsers,
      totalChats: result.totalReplies,
      totalSessions: result.totalSessions,
      totalLocations: result.totalLocations,
    });
  };

  useEffect(() => {
    if (chartsData) {
      calculateAverageData();
    } else {
      setDashboardOverviewData({
        totalUsers: 0,
        totalChats: 0,
        totalSessions: 0,
        totalLocations: 0,
      });
    }
  }, [chartsData]);

  return (
    <>
      <div className="overview-dash-wrap">
        <div className="overview-card">
          <div className="user-img-dashbord-icon"></div>
          <div className="overview-text">
            <div className="large-font">
              {dashboardOverviewData?.totalUsers
                ? dashboardOverviewData?.totalUsers
                : 0}
            </div>
            <div className="small-font">Total Distinct Users</div>
          </div>
        </div>
        <div className="overview-card">
          <div className="chats-img-dashbord-icon"></div>
          <div className="overview-text">
            <div className="large-font">
              {" "}
              {dashboardOverviewData?.totalChats
                ? dashboardOverviewData?.totalChats
                : 0}
            </div>
            <div className="small-font">Total Chats</div>
          </div>
        </div>
        <div className="overview-card">
          <div className="session-img-dashbord-icon"></div>
          <div className="overview-text">
            <div className="large-font">
              {dashboardOverviewData?.totalSessions
                ? dashboardOverviewData?.totalSessions
                : 0}
            </div>
            <div className="small-font">Total Sessions</div>
          </div>
        </div>
        {/* <div className="overview-card">
          <div className="location-img-dashbord-icon"></div>
          <div className="overview-text">
            <div className="large-font">
              {" "}
              {dashboardOverviewData?.totalLocations
                ? dashboardOverviewData?.totalLocations
                : 0}
            </div>
            <div className="small-font">Total Locations</div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default OverviewDashboard;
